import React, { useState } from 'react';
import { Section } from './ui/Section';
import { ChevronDown } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function FAQ() {
  const faqs = [{
    q: '¿No es muy caro tener una web profesional?',
    a: 'La pregunta correcta es: ¿cuánto estás perdiendo cada mes por no tener una? Una web profesional se paga sola con el primer cliente que convierte.'
  }, {
    q: '¿No puedo hacer yo mismo mi web?',
    a: 'Puedes. Pero hacer una web que realmente convierta requiere años de experiencia en diseño, marketing y psicología del comprador. El tiempo que inviertes en aprenderlo es tiempo que no estás generando ingresos.'
  }, {
    q: '¿Cuánto tiempo toma el proceso?',
    a: 'Trabajamos de forma ágil y enfocada para que tengas resultados reales en el menor tiempo posible. Conversemos y te doy un plazo específico para tu proyecto.'
  }, {
    q: '¿Cómo sé que va a funcionar para mi negocio?',
    a: 'Más de 100 emprendedores de servicios ya han pasado por este proceso con resultados reales. Además, comenzamos con una conversación para asegurarnos de que el enfoque sea perfecto para tu caso particular.'
  }, {
    q: 'Ya tengo redes sociales, ¿para qué necesito una web?',
    a: 'Las redes sociales son alquiladas. Tu web es tuya. El algoritmo puede desaparecer mañana; tu activo digital no. Además, una web convierte a un nivel que las redes sociales no pueden igualar.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <Section id="faq" className="bg-[#0F1525]" data-id="element-66">
      <div className="max-w-3xl mx-auto" data-id="element-67">
        <div className="text-center mb-12" data-id="element-68">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-69">
            Preguntas Frecuentes
          </h2>
          <p className="text-slate-400" data-id="element-70">
            Todo lo que necesitas saber antes de empezar.
          </p>
        </div>

        <div className="space-y-4" data-id="element-71">
          {faqs.map((faq, index) => <div key={index} className="bg-brand-surface border border-white/5 rounded-2xl overflow-hidden" data-id="element-72">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-6 text-left" data-id="element-73">
                <span className="text-lg font-bold text-white pr-8" data-id="element-74">
                  {faq.q}
                </span>
                <ChevronDown className={`w-5 h-5 text-brand-accent flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-75" />
              </button>

              <AnimatePresence data-id="element-76">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-77">
                    <div className="px-6 pb-6 text-slate-300 leading-relaxed border-t border-white/5 pt-4" data-id="element-78">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </Section>;
}